const _excluded = ["content_type"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { useParams } from 'react-router';
import React from 'react';
import { SpinnerReact } from 'common/components/spinner';
import { SpinnerSize } from 'common/components/spinner/types';
import { useFeatureFlagStore } from 'iron/apps/feature-flags/src/store';
import { ContentPage } from 'common/content/page';
import { Content } from 'common/types/app-api/content';
import { FeatureFlagPageProvider } from '../context';
import { useQueryFeatureFlag } from '../hooks/queryFeatureFlag';
import { FeatureFlagPageConfiguration } from './configuration';
import { FeatureFlagPageMain } from './main';
interface FeatureFlagPageProps {
  projectId: number;
  workspaceId: number;
  userId: number;
}
export function FeatureFlagPage(_ref: FeatureFlagPageProps) {
  let {
    projectId,
    workspaceId,
    userId
  }: FeatureFlagPageProps = _ref;
  const {
    flagId
  } = useParams();
  useQueryFeatureFlag({
    projectId,
    flagId: flagId || ""
  });
  const currentFeatureFlag = useFeatureFlagStore(state => state.currentFeatureFlag);
  const setCurrentFeatureFlag = useFeatureFlagStore(state => state.setCurrentFeatureFlag);
  if (!currentFeatureFlag) return <SpinnerReact size={SpinnerSize.Large} />;
  return <FeatureFlagPageProvider projectId={projectId} workspaceId={workspaceId} userId={userId} featureFlagId={flagId} data-sentry-element="FeatureFlagPageProvider" data-sentry-component="FeatureFlagPage" data-sentry-source-file="index.tsx">
      <ContentPage content={currentFeatureFlag as Content} projectId={projectId} workspaceId={workspaceId} userId={userId} minWidth={1200} onUpdate={_ref2 => {
      let {
          content_type: _
        } = _ref2,
        content = _objectWithoutProperties(_ref2, _excluded);
      return setCurrentFeatureFlag(_objectSpread(_objectSpread({}, currentFeatureFlag), content));
    }} data-sentry-element="ContentPage" data-sentry-source-file="index.tsx">
        <FeatureFlagPageMain data-sentry-element="FeatureFlagPageMain" data-sentry-source-file="index.tsx" />
        <FeatureFlagPageConfiguration data-sentry-element="FeatureFlagPageConfiguration" data-sentry-source-file="index.tsx" />
      </ContentPage>
    </FeatureFlagPageProvider>;
}